import React from 'react';
import { map } from 'lodash';
import classnames from 'classnames';

import { withNetworkState } from 'ui/hoc/withNetworkState';
import { heartBeatPreloader as HeartBeatPreloader } from 'ui/views/generic/heartBeatPreloader';
import { WIDGET_NAMES } from 'constants/entity-names';
import { MemberCheckoutAssigningCoverage } from 'ui/containers/MemberCheckoutAssigningCoverage';
import { MemberSavedAddress } from 'ui/containers/MemberSavedAddress';
import { MemberCheckoutPaymentOptions } from 'ui/containers/MemberCheckoutPaymentOptions';
import { MemberCheckoutShippingOptions } from 'ui/containers/MemberCheckoutShippingOptions';
import { MemberCheckoutCostInformation } from 'ui/containers/MemberCheckoutCostInformation';
import { button as Button } from 'modules/button';

// widget views
const WIDGET_VIEWS = {
    [ WIDGET_NAMES.CHECKOUT_SHIPPING_STEP_ASSIGNING_COVERAGE ]: MemberCheckoutAssigningCoverage,
    [ WIDGET_NAMES.CHECKOUT_SHIPPING_STEP_SHIPPING_OPTIONS ]: MemberCheckoutShippingOptions,
    [ WIDGET_NAMES.CHECKOUT_SHIPPING_STEP_COST_INFORMATION ]: MemberCheckoutCostInformation,
    [ WIDGET_NAMES.CHECKOUT_SHIPPING_STEP_PAYMENT_OPTIONS ]: MemberCheckoutPaymentOptions,
    [ WIDGET_NAMES.CHECKOUT_SHIPPING_STEP_SAVED_ADDRESS ]: MemberSavedAddress
};

const _shipppingAndPayment = ( props ) => {

    return (
        <div className='ui-shippping-and-payment'>
            <div className='ui-shippping-and-payment__widgets'>
                {
                    map( props.widgets, widget => {

                        // get widget view
                        const WidgetView = WIDGET_VIEWS[ widget.name ];

                        // widget class name
                        const widgetClassName = classnames( 'ui-shippping-and-payment__widgets__widget' );

                        return (
                            <div key={ widget.name } className={ widgetClassName }>
                                <WidgetView
                                    widget={ widget }
                                    updateZip= { props.updateZip }
                                    zipCode={ props.zipCode }
                                    updateCheckoutSelection={ props.updateCheckoutSelection }
                                    shippingCharges={ props.shippingCharges }
                                    isPaymentRequired={ props.isPaymentRequired }
                                    requestPayload={ props.requestPayload }
                                    stepIndex={ props.stepIndex }
                                    origin={ props.origin }

                                    selectedPaymentOptionId={ props.selectedPaymentOptionId }
                                    updateEnableNextForDavita={ props.updateEnableNextForDavita }
                                />
                            </div>
                        );
                    } )
                }
                
            </div>

            <div className='ui-shippping-and-payment__actions'>
                { map( props.navActions, action => {
                    return (
                        <Button
                            key={ action.name }
                            className='ui-shippping-and-payment__actions__action'
                            size='large'
                            showIcon={ 'prev' === action.name }
                            iconId={ 'leftArrow'}
                            showPostIcon={ 'next' === action.name }
                            postIconId={ 'arrow'}
                            iconWidth={ 18 }
                            iconHeight={ 18 }
                            title={ action.title }
                            onClick={ () => props.onNavActionClick( { value: action } ) }
                            outline={ 'next' === action.name ? false: true }
                            disabled={ 'next' === action.name && ! props.canMoveForward ? true: false }
                        />
                    );
                } ) }
            </div>
           
        </div>
    );
};

// set display name
_shipppingAndPayment.displayName = 'shipppingAndPayment';

// set default props
_shipppingAndPayment.defaultProps = {};

// prop types
_shipppingAndPayment.propTypes = {};

/*************************************** */

// preloader view
const shipppingAndPaymentPreloader= () => {
    return (
        <div className='ui-shippping-and-payment-preloader'>
            <HeartBeatPreloader />
        </div>
    );
};

// set display name
shipppingAndPaymentPreloader.displayName = 'shipppingAndPaymentPreloader';

// set default props
shipppingAndPaymentPreloader.defaultProps = {};

// prop types
shipppingAndPaymentPreloader.propTypes = {};

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { shipppingAndPayment as ShipppingAndPayment } from 'ui/views/widgets/shipppingAndPayment';
 *
 * // render
 * <ShipppingAndPayment propName='propValue'/>
 */
export const shipppingAndPayment = withNetworkState( shipppingAndPaymentPreloader, _shipppingAndPayment );
